<template>
  <vue-html2pdf
    v-if="canGeneratePdf"
    :show-layout="false"
    :float-layout="true"
    :preview-modal="true"
    :enable-download="false"
    :paginate-elements-by-height="1400"
    filename="Demonstrativo"
    :pdf-quality="2"
    :manual-pagination="false"
    pdf-format="a4"
    pdf-content-width="800px"
    :html-to-pdf-options="htmlToPdfOptions"
    ref="html2Pdf"
  >
    <section id="report-box" slot="pdf-content">
      <div class="report-box">
        <table cellpadding="0" cellspacing="0">
          <tr class="top">
            <td colspan="2">
              <table class="header">
                <tr>
                  <td
                    class="header-left"
                    style="border-left: 10px solid #4662d4; text-align: center;"
                  >
                    <div style="padding-right: 20px; padding-top: 3px;">
                      <span
                        style="
                          line-height: 30px;
                          font-size: 11px;
                          text-transform: uppercase;
                          background: #343a40;
                          color: #ffffff;
                          padding: 5px;
                        "
                      >
                        Processo de Importação
                      </span>
                      <br />
                      <span
                        style="
                          line-height: 45px;
                          font-size: 40px;
                          font-weight: 400;
                        "
                      >
                        {{ processReference }}
                      </span>
                      <br />
                    </div>
                  </td>
                  <td class="header-middle" valign="top" v-if="process.account !== null">
                    <strong>
                      {{
                        process.account.completeName !== null
                          ? process.account.completeName
                          : ""
                      }}
                    </strong>
                    <br />
                    CNPJ:
                    {{
                      process.account.federalID ? process.account.federalID : ""
                    }}
                    <br />
                    Inscrição Municipal:
                    {{
                      process.account.municipalRegistration
                        ? process.account.municipalRegistration
                        : ""
                    }}
                    / IE:
                    {{
                      process.account.stateRegistration
                        ? process.account.stateRegistration
                        : ""
                    }}
                    <br />
                    Matriz:
                    {{ process.account.city ? process.account.city : "" }} /
                    {{
                      process.account.federalUnity
                        ? process.account.federalUnity
                        : ""
                    }}
                    <br />
                  </td>
                  <td class="header-right" align="right" valign="top">
                    <div style="padding-top: 15px;">
                      <img
                        v-if="
                          process.account.id === 3 &&
                          process.account.federalID === '49744122000181'
                        "
                        src="@/assets/img/sow-logo-azul-naval.png"
                        width="190"
                      />
                      <img
                        v-else
                        src="@/assets/img/logo-horizontal-azul.png"
                        style="width: 190px"
                      />
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr>
            <td colspan="2">
              <br />
              <h1 class="slim-pagetitle">
                CAPA DO PROCESSO DE IMPORTAÇÃO #{{
                  process.identification ? process.identification : ""
                }}
              </h1>
            </td>
          </tr>

          <tr class="information">
            <td colspan="2">
              <table class="no-border info-table">
                <tr class="info-row">
                  <td class="label">NUM / REF CLIENTE</td>
                  <td class="value">
                    {{ process.customerRef !== null ? process.customerRef : "" }}
                  </td>
                </tr>
                <tr class="info-row" v-if="process.customer !== null">
                  <td class="label">CLIENTE</td>
                  <td class="value" colspan="3">
                    {{
                      process.customer.completeName !== null
                        ? process.customer.completeName
                        : ""
                    }}
                  </td>
                </tr>
                <tr class="info-row" v-if="process.exporter !== null">
                  <td class="label">EXPORTADOR</td>
                  <td class="value" colspan="3">
                    {{
                      process.exporter.name !== null ? process.exporter.name : ""
                    }}
                  </td>
                </tr>
                <tr class="info-row" v-if="process.wayOfTransport !== null">
                  <td class="label">TIPO DE FRETE</td>
                  <td class="value uppercase">
                    <span v-if="process.wayOfTransport === 'MARITIMA'">Marítimo</span>
                    <span v-if="process.wayOfTransport === 'AEREA'">Aéreo</span>
                    <span v-if="process.wayOfTransport === 'RODOVIARIO'">Rodoviário</span>
                  </td>
                  <td class="label">CONHECIMENTO</td>
                  <td class="value">
                    {{
                      process.billOfLading !== null
                        ? process.billOfLading
                        : ""
                    }}
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr>
            <td colspan="2">
              <br />
              <h1 class="slim-pagetitle">OBSERVAÇÕES</h1>
            </td>
          </tr>

          <tr>
            <td colspan="2">
              <br />
              <hr />
              <br />
              <hr />
              <br />
              <hr />
              <br />
              <hr />
            </td>
          </tr>
        </table>
        <div class="footer">
          <small> RQ 108 </small>
          <br />
          <small>REV 03 - 08/2018 </small>
          <br />
        </div>
      </div>
    </section>
  </vue-html2pdf>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf';
import demonstrativePdfStyles from '@/utils/demonstrative-pdf-styles';

export default {
  name: 'ProcessDemonstrativePdf',
  components: {
    VueHtml2pdf,
  },
  props: {
    process: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      htmlToPdfOptions: {
        margin: 0,
        filename: 'Demonstrativo.pdf',
        image: {
          type: 'jpeg',
          quality: 0.98,
        },
        enableLinks: false,
        html2canvas: {
          scale: 2,
          useCORS: true,
          onclone: (clonedDoc) => {
            const style = clonedDoc.createElement('style');
            style.type = 'text/css';
            style.appendChild(clonedDoc.createTextNode(demonstrativePdfStyles));
            clonedDoc.head.appendChild(style);

            clonedDoc.querySelectorAll('#report-box .info-row td').forEach((cell) => {
              cell.style.setProperty('border-bottom', '1px dashed #dee2e6', 'important');
              cell.style.setProperty('padding', '2px 0 2px 0', 'important');
            });
          },
        },
        jsPDF: {
          unit: 'in',
          format: 'a4',
          orientation: 'portrait',
        },
      },
    };
  },
  computed: {
    canGeneratePdf() {
      return (
        this.process
        && this.process.customer
        && this.process.customer !== null
        && this.process.account
        && this.process.account !== null
        && this.process.id !== undefined
        && this.process.id !== null
      );
    },
    processReference() {
      if (this.process === null || this.process.identification === null) return 'N/I';

      let ref = '';
      let typeOfProcess = '';
      const zerosToLeft = 5;

      if (this.process.typeOfProcess !== null) {
        typeOfProcess = this.process.typeOfProcess;
      }

      const zero = zerosToLeft - this.process.identification.toString().length + 1;
      const zeroPad = Array(+(zero > 0 && zero)).join('0') + this.process.identification;

      if (typeOfProcess === 'ASSESSORIA') {
        ref = `A${zeroPad}`;
      } else if (typeOfProcess === 'ENCOMENDA') {
        ref = `E${zeroPad}`;
      } else {
        ref = `PRI${zeroPad}`;
      }

      return ref;
    },
  },
  methods: {
    formatNumeral(value) {
      if (value === null || value === undefined || value === '') {
        return '';
      }

      return Number(value).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    generatePdf() {
      if (this.$refs.html2Pdf) {
        this.$refs.html2Pdf.generatePdf();
      }
    },
  },
};
</script>

<style>
.report-box {
  position: relative;
  min-height: 1050px;
  max-width: 800px;
  padding: 5px 20px 5px 5px;
  margin: 20px;
  box-sizing: border-box;
  font-size: 16px;
  line-height: 24px;
  font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
  color: #343a40;
}

.report-box table {
  width: 100%;
}

#report-box .slim-pagetitle {
  margin-top: 15px;
  margin-bottom: 10px;
  color: #343a40;
  padding-left: 10px;
  border-left: 4px solid #4662d4;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #343a40;
  padding: 5px;
  margin-left: 10px;
  margin-right: 10px;
}

#report-box hr {
  border: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  margin-bottom: 5px;
}

#report-box .header {
  font-size: 12px;
}

#report-box .header-left {
  text-align: center;
  border-left: 10px solid #4662d4 !important;
}

#report-box .header-middle {
  padding-left: 20px;
  text-align: left !important;
  line-height: 20px;
}

#report-box .header-right {
  vertical-align: middle;
  line-height: 10px;
}

#report-box .info-row,
#report-box .info-row-simple {
  font-size: 14px;
}

#report-box .information table.info-table {
  margin: 10px;
}

#report-box .report-box table:not(.info-table) td,
#report-box .report-box table:not(.info-table) th {
  padding: 0 !important;
  background-color: transparent !important;
  min-width: 0 !important;
  border-top: 0 !important;
  border-right: 0 !important;
  border-bottom: 0 !important;
}

#report-box .information table.info-table tr.info-row td {
  padding: 2px 0 2px 0 !important;
  background-color: transparent !important;
  min-width: 0 !important;
  border-top: 0 !important;
  border-right: 0 !important;
  border-bottom: 1px dashed #dee2e6 !important;
}

#report-box .info-row td.label {
  text-align: left;
  font-weight: bold;
}

#report-box .info-row td.value {
  text-align: left;
}

#report-box .footer {
  position: absolute;
  left: 0;
  bottom: 10px;
  width: 100%;
  text-align: center;
  line-height: 8px;
}

#report-box .footer small {
  font-size: 9px;
}

#report-box,
#report-box * {
  font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif !important;
}

#report-box h1 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  line-height: 18px;
  color: #343a40;
}
</style>
